function PillsIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="49"
      height="42"
      viewBox="0 0 49 42"
      fill="none"
    >
      <path
        d="M37.2791 1.82776C39.8305 1.82776 42.3884 2.92496 44.2952 4.84175C47.9735 8.53652 48.3073 14.1944 45.0322 17.4562L24.701 37.7048C23.2601 39.1423 21.274 39.9322 19.1093 39.9322C16.558 39.9322 14.0001 38.835 12.0932 36.9182C8.41495 33.2234 8.08116 27.5656 11.3562 24.3038L31.6874 4.0552C33.1283 2.61761 35.1145 1.82776 37.2791 1.82776ZM37.2758 0.105957C34.751 0.105957 32.3054 1.00487 30.4712 2.83573L10.1401 23.0843C6.19742 27.0137 6.5246 33.7654 10.8737 38.1311C13.197 40.4643 16.2077 41.6507 19.1093 41.6507C21.6342 41.6507 24.0797 40.7518 25.9139 38.9209L46.2451 18.6724C50.1877 14.7429 49.8605 7.99123 45.5114 3.62558C43.1881 1.29238 40.1775 0.105957 37.2758 0.105957Z"
        fill="var(--peach-dark)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.4268 27.6847L21.4395 12.6379L31.225 2.89202C34.9792 -0.849025 41.3774 -0.511935 45.5183 3.64551C49.6559 7.79966 49.9699 14.2011 46.2156 17.9388L36.4301 27.6847H36.4268Z"
        fill="var(--peach-dark)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5064 0.072885C5.87968 -0.508761 1.44132 2.44243 0.281331 7.08238C-0.878657 11.7223 1.64951 16.4152 6.00525 18.0775L10.5064 0.072885Z"
        fill="var(--peach-dark)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6974 0.621582L8.19629 18.6262C12.823 19.2078 17.2614 16.2566 18.4214 11.6167C19.5814 6.97673 17.0532 2.2839 12.6974 0.621582Z"
        fill="var(--peach-dark)"
      />
    </svg>
  );
}

export default PillsIcon;
